const routes = {
    path: 'atendimentos',
    name: 'Expressos_Atendimentos',
    component: () => import('./Listagem.vue'),
    meta: {
        rules: ['EXPR-ATEN-00'],
    },
    children: [
        {
            path: ':id',
            name: 'Expressos_Atendimentos_Detalhar',
            component: () => import('./Detalhar.vue'),
            meta: {
                rules: ['EXPR-ATEN-00'],
            },
        },
    ],
};

export default routes;
